var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHappHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132px",
    height: "42px",
    viewBox: "0 0 132 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "51.9254756%",
    fx: "50%",
    fy: "51.9254756%",
    r: "51.2744913%",
    gradientTransform: "translate(0.500000,0.519255),scale(1.000000,0.937591),rotate(90.000000),translate(-0.500000,-0.519255)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0050FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0050FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-40.0%",
    y: "-44.4%",
    width: "180.0%",
    height: "188.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.831372549  0 0 0 0.385161713 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-654.000000, -35.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(655.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(45.000000, 1.500000)",
    fill: "#0050FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5684055,30.0320856 C17.1252461,30.0320856 18.2192421,29.6149733 19.4394685,28.6973262 L19.4394685,23.4417112 C19.0607776,23.6919786 18.7662402,23.8171123 18.3033957,23.8171123 C17.882628,23.8171123 17.4618602,23.6085561 17.4618602,22.8994652 L17.4618602,17.5604278 C17.4618602,13.9315508 15.6525591,11.7625668 12.0760335,11.7625668 C10.3929626,11.7625668 8.70989173,12.3465241 7.23720472,14.0566845 L7.23720472,0 L0,0 L0,29.6149733 L7.23720472,29.6149733 L7.23720472,18.8951872 C7.44758858,18.0609626 8.1628937,17.6855615 8.7519685,17.6855615 C9.67765748,17.6855615 10.2246555,18.2278075 10.2246555,19.3122995 L10.2246555,24.1090909 C10.2246555,28.2802139 12.4968012,30.0320856 15.5684055,30.0320856 Z M38.2057087,30.0320856 C39.6363189,30.0320856 40.8565453,29.6149733 42.0767717,28.6973262 L42.0767717,23.4417112 C41.6980807,23.6919786 41.4035433,23.8171123 40.9406988,23.8171123 C40.5199311,23.8171123 40.0991634,23.6085561 40.0991634,22.8994652 L40.0991634,12.1796791 L32.8619587,12.1796791 L32.8619587,13.6812834 C31.5996555,12.2631016 30.1269685,11.7625668 28.4438976,11.7625668 C23.1843012,11.7625668 20.2810039,16.0588235 20.2810039,20.8973262 C20.2810039,25.8609626 23.1843012,30.0320856 28.4438976,30.0320856 C30.4215059,30.0320856 32.1045768,29.3229947 33.4931102,27.2791444 C34.3346457,28.9893048 35.933563,30.0320856 38.2057087,30.0320856 Z M30.3373524,24.1090909 C28.6122047,24.1090909 27.4340551,22.8994652 27.4340551,20.8973262 C27.4340551,18.8951872 28.6122047,17.6855615 30.3373524,17.6855615 C31.4313484,17.6855615 32.3149606,18.144385 32.8619587,19.0620321 L32.8619587,22.7326203 C32.3149606,23.6502674 31.4313484,24.1090909 30.3373524,24.1090909 Z M50.7866634,39 L50.7866634,28.113369 C52.2172736,29.6149733 53.4795768,30.0320856 55.2047244,30.0320856 C60.4643209,30.0320856 63.3676181,25.8609626 63.3676181,20.8973262 C63.3676181,16.0588235 60.4643209,11.7625668 55.2047244,11.7625668 C53.5216535,11.7625668 52.0489665,12.2631016 50.7866634,13.6812834 L50.7866634,12.1796791 L43.5494587,12.1796791 L43.5494587,39 L50.7866634,39 Z M53.3112697,24.1090909 C52.2172736,24.1090909 51.3336614,23.6502674 50.7866634,22.7326203 L50.7866634,19.0620321 C51.3336614,18.144385 52.2172736,17.6855615 53.3112697,17.6855615 C55.0364173,17.6855615 56.2145669,18.8951872 56.2145669,20.8973262 C56.2145669,22.8994652 55.0364173,24.1090909 53.3112697,24.1090909 Z M72.9190453,39 L72.9190453,28.113369 C74.3496555,29.6149733 75.6119587,30.0320856 77.3371063,30.0320856 C82.5967028,30.0320856 85.5,25.8609626 85.5,20.8973262 C85.5,16.0588235 82.5967028,11.7625668 77.3371063,11.7625668 C75.6540354,11.7625668 74.1813484,12.2631016 72.9190453,13.6812834 L72.9190453,12.1796791 L65.6818406,12.1796791 L65.6818406,39 L72.9190453,39 Z M75.4436516,24.1090909 C74.3496555,24.1090909 73.4660433,23.6502674 72.9190453,22.7326203 L72.9190453,19.0620321 C73.4660433,18.144385 74.3496555,17.6855615 75.4436516,17.6855615 C77.1687992,17.6855615 78.3469488,18.8951872 78.3469488,20.8973262 C78.3469488,22.8994652 77.1687992,24.1090909 75.4436516,24.1090909 Z",
    id: "happ-copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield-solid-(1)",
    fill: "url(#radialGradient-1)",
    stroke: "#6998FF",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9956055,6.13037109 L18.9331055,0.270996094 C18.0679706,-0.0878968006 17.0956036,-0.0878968006 16.2304688,0.270996094 L2.16796875,6.13037109 C0.856933594,6.67236328 0,7.95410156 0,9.375 C0,23.9135742 8.38623047,33.9624023 16.2231445,37.2290039 C17.0874023,37.5878906 18.0615234,37.5878906 18.9257812,37.2290039 C25.2026367,34.6142578 35.15625,25.5834961 35.15625,9.375 C35.15625,7.95410156 34.2993164,6.67236328 32.9956055,6.13037109 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heart-solid-(2)",
    filter: "url(#filter-2)",
    transform: "translate(7.687500, 9.937500)",
    fill: "#00FFD4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9166797,1.22203125 C15.7974609,-0.583945313 12.6457031,-0.259101563 10.7005078,1.74796875 L9.93867187,2.53300781 L9.17683594,1.74796875 C7.23550781,-0.259101563 4.07988281,-0.583945313 1.96066406,1.22203125 C-0.467929687,3.29484375 -0.595546875,7.01507813 1.5778125,9.26191406 L9.06082031,16.9885547 C9.54421875,17.4874219 10.3292578,17.4874219 10.8126563,16.9885547 L18.2956641,9.26191406 C20.4728906,7.01507813 20.3452734,3.29484375 17.9166797,1.22203125 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHappHeart);
export default __webpack_public_path__ + "static/media/logo-happ-heart.9f6640d77984109fd07937d79d11118e.svg";
export { ForwardRef as ReactComponent };